import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from 'src/app/services/lang.service';
import { MlTranslationService } from 'src/app/services/ml-translation.service';
import {
  DhProfileConfigService,
  DhProfileLandingSummary,
} from 'src/app/services/dh-profile-config.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  public loading: boolean = true;
  public currentLang: string = 'en';
  public infoCards: any = [
    {
      level: 'Level7:Perplexity',
      img: '/assets/img/dh-landing/level7.png',
      subtitle: 'level:7:short:description',
      description: '',
      button: '',
      color: '#5B1F78',
    },
    {
      level: 'Level6:Simplexity',
      img: '/assets/img/dh-landing/level6.png',
      subtitle: 'level:6:short:description',
      description: '',
      button: '',
      color: '#004B93',
    },
    {
      level: 'Level5:Complexity',
      img: '/assets/img/dh-landing/level5.png',
      subtitle: 'level:5:short:description',
      description: '',
      button: '',
      color: '#009EE0',
    },
    {
      level: 'Level4:Relationality',
      img: '/assets/img/dh-landing/level4.png',
      subtitle: 'level:4:short:description',
      description:
        'Do you want to know more about your behaviour in a Team? Or about how well the roles in your team are adjusted to what you are doing at the moment? Then create a Teamrole profile.',
      button: 'Learn more',
      color: '#41A62A',
      route: 'level-4',
    },
    {
      level: 'Level3:Maximality',
      img: '/assets/img/dh-landing/level3.png',
      subtitle: 'level:3:short:description',
      description:
        'We are currently creating the questionnaire to create your Double Healix Competency profile. You can try it out for free.',
      button: 'Learn more',
      color: '#FFCC00',
      route: 'level-3',
    },
    {
      level: 'Level2:Sensationality',
      img: '/assets/img/dh-landing/level2.png',
      subtitle: 'level:2:short:description',
      description: '',
      button: '',
      color: '#EE7F00',
    },
    {
      level: 'Level1:Simplicity',
      img: '/assets/img/dh-landing/level1.png',
      subtitle: 'level:1:short:description',
      description: '',
      button: '',
      color: '#E2001A',
    },
    {
      level: 'Level0:Universality',
      img: '/assets/img/dh-landing/level0.png',
      subtitle: 'level:0:short:description',
      description: '',
      button: '',
      color: '#8A9199',
    },
  ];
  public currentRoute: string = '';
  public enabledLandings: DhProfileLandingSummary[] = [];

  constructor(
    private lang: LangService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private dhConfig: DhProfileConfigService,
    private mlTranslation: MlTranslationService
  ) {
    this.lang.language.subscribe((lang) => {
      this.currentLang = lang || 'en';
    });
  }
  ngOnInit(): void {
    this.dhConfig
      .listPublicLandings()
      .then((rows) => {
        // Sort ascending by level (1 → 7)
        this.enabledLandings = (rows || []).sort((a, b) => a.level - b.level);
      })
      .catch(() => {
        this.enabledLandings = [];
      });

    this.activatedRoute.url.subscribe((url) => {
      this.currentRoute = url.join('/');
      setTimeout(() => {
        // Keep the language picked in the AI translation widget
        if (this.mlTranslation.isEnabled()) return;
        if (this.currentRoute) {
          if (this.currentRoute == 'doublehealixprofiel') {
            this.lang.setLanguage('nl');
          }
          if (this.currentRoute == 'doublehealixprofile') {
            this.lang.setLanguage('en');
          }
        }
      }, 1000);
    });
    this.activatedRoute.params.subscribe(({ lang }) => {
      setTimeout(() => {
        if (this.mlTranslation.isEnabled()) return;
        if (lang) {
          if (lang == 'nl') {
            this.lang.setLanguage('nl');
          }
          if (lang == 'en') {
            this.lang.setLanguage('en');
          }
        }
      }, 1000);
    });
  }
  ngAfterViewInit(): void {
    this.checkCurrentRoute();
  }

  public checkCurrentRoute() {
    // Verifica si la URL actual es /dh/level-3 o /dh/level-4
    if (this.router.url === '/dh/landing/nl') {
      this.router.navigate(['/doublehealixprofiel']);
    }
    if (this.router.url === '/dh/landing/en') {
      this.router.navigate(['/doublehealixprofile']);
    }
  }
  goTo(route: any) {
    this.router.navigate(['/dh', route]);
  }

  /**
   * Text (title/description/button) for a landing entry using the current language,
   * with fallback to en/nl when a value is empty.
   */
  public landingText(entry: DhProfileLandingSummary, field: 'title' | 'description' | 'button_text'): string {
    const l = entry?.landing as any;
    if (!l) return '';
    // AI translation adds <field>_<lang> for languages other than en/nl
    if (l[field + '_' + this.currentLang]) return l[field + '_' + this.currentLang];
    if (this.currentLang === 'en') return l[field + '_en'] || l[field + '_nl'] || '';
    return l[field + '_nl'] || l[field + '_en'] || '';
  }

  public openLanding(entry: DhProfileLandingSummary): void {
    const l: any = entry?.landing;
    if (!l) return;
    const raw = this.currentLang === 'en'
      ? (l.button_link_en || l.button_link_nl)
      : (l.button_link_nl || l.button_link_en);
    if (!raw) return;

    if (/^https?:\/\//i.test(raw)) {
      window.open(raw, '_blank');
      return;
    }
    // Internal path — support leading slash or not, and slash-separated segments
    const segments = raw.replace(/^\/+/, '').split('/').filter(Boolean);
    this.router.navigate(['/' + segments[0], ...segments.slice(1)]);
  }
}
